import React, { ChangeEvent } from "react";
import { useQuery } from "react-query";
import { Assort } from "../../app/models/Assort";
import { standardizedGet } from "../../app/api/standarizedApiClient";
import { GET_TICKETS_MOVIE_URL } from "../../app/api/apiRoutes";
import getId from "../../utils/getId";
import useFacility from "../../utils/hooks/useFacility";
import LoadableComponent from "../Loading/LoadableComponent";
import { Exercise } from "../../app/models/Exercise";
import { BasketItem } from "../../app/models/BasketItem";
import { useTranslation } from "react-i18next";

interface IProps {
  exercise: Exercise;
  onChangeSelect: (assortIds: string) => void;
  basketItem: BasketItem;
}

const AssortSelector: React.FC<IProps> = ({ exercise, onChangeSelect, basketItem }: IProps) => {
  const { t } = useTranslation();
  const facilityIds = useFacility();
  const { isLoading, data } = useQuery<Assort[], string>("tickets", async () =>
    standardizedGet(GET_TICKETS_MOVIE_URL(facilityIds, getId(exercise)))
  );

  return (
    <LoadableComponent loading={isLoading}>
      <select
        defaultValue={basketItem ? basketItem.assortIds : "0,0"}
        onChange={(event: ChangeEvent<HTMLSelectElement>) => {
          onChangeSelect(event.target.value);
        }}
      >
        {basketItem.assortIds === "" && (
          <option selected={basketItem.assortIds === ""} value={"0,0"}>
            {t("wybierz_bilet")}
          </option>
        )}
        {data?.map((item, index) => (
          <option key={index} selected={basketItem.assortIds === getId(item)} value={getId(item)}>{`${item.name} ${
            item.price
          } ${t("zl")}`}</option>
        ))}
      </select>
    </LoadableComponent>
  );
};

export default AssortSelector;
